
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-does-nexplanon-work",
      function () {
        return require("private-next-pages/how-does-nexplanon-work.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-does-nexplanon-work"])
      });
    }
  